import jQuery from "../modules/jquery/jquery-3.6.1.min.js"
jQuery(document).ready(function($) {
	$('.tab-link').click(function() {
		var $this = $(this),
		tab_id = $(this).data('tab');
		$('.tab-link').removeClass('active');
		$('.tab-content').removeClass('active');
		$('#'+tab_id).addClass('active');
		$(this).addClass('active').trigger('tab-changed');
	});
});